const style = {
  users: {
    backgroundColor: '#fff',
    minHeight: '100%',
  },
};

export default style;
